const OpenIdKey = 'OpenId'
const YzjIdKey = 'YzjId'

export function getOpenId() {
  if (process.env.NODE_ENV === 'production') {
    return localStorage.getItem(OpenIdKey)
  } else {
    return ''
  }
}

export function setOpenId(openId) {
  return localStorage.setItem(OpenIdKey, openId)
}

export function removeOpenId() {
  return localStorage.removeItem(OpenIdKey)
}

export function getYzjOpenId() {
  if (process.env.NODE_ENV === 'production') {
    return localStorage.getItem(YzjIdKey)
  } else {
    return '22222'
  }
}

export function setYzjOpenId(YzjId) {
  return localStorage.setItem(YzjIdKey, YzjId)
}

export function removeYzjOpenId() {
  return localStorage.removeItem(YzjIdKey)
}

